module.directive('address', function() {
  return {
    restrict: 'E',
    templateUrl: 'util/widgets/address',
    scope: {address: '=', map: '='},
  };
});